// extracted by mini-css-extract-plugin
export default {"layout":"VerifySecondaryEmail_layout__SKtrL","panel":"VerifySecondaryEmail_panel__v8GKH","info":"VerifySecondaryEmail_info__Y4zaL","error":"VerifySecondaryEmail_error__QUtpG"};